<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="用户名称：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入用户名称/手机号搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="userId"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="headPicture"
            label="头像">
            <template slot-scope="scope">
              <el-image
                style="width: 40px;border-radius: 40px;"
                :src="scope.row.headPicture == null ? imgServer+'no_img.png' : scope.row.headPicture"
                :preview-src-list="[scope.row.headPicture]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="promoterName"
            label="用户身份">
            <template slot-scope="scope">
              <span>{{scope.row.promoterName == '' || scope.row.promoterName == null ? '--' : scope.row.promoterName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="referenceNumber"
            label="下级总数">
          </el-table-column>
          <el-table-column
            align="center"
            prop="addUpCommissionMoney"
            label="累计佣金">
          </el-table-column>
          <el-table-column
            align="center"
            prop="commissionMoney"
            label="可提现金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="toCreditedCommissionMoney"
            label="待入账">
          </el-table-column>
          <el-table-column
            align="center"
            prop="applyWithdrawalMoney"
            label="提现中">
          </el-table-column>
          <el-table-column
            align="center"
            prop="promotionTime"
            width="130"
            label="成为推广员时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toPromoteBtn(scope.row.userId)" type="text" size="small">推广用户</el-button>
              <el-button @click="toOrderBtn(scope.row.userId)" type="text" size="small">推广订单</el-button>
              <el-button @click="updateUserOpenBtn(scope.row.userId)" type="text" size="small">更改上级</el-button>
              <el-button @click="rankOpenBtn(scope.row.userId)" type="text" size="small">分销等级</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 更改上级弹窗 -->
    <el-dialog
      title="更改上级"
      :visible.sync="updateUserShow"
      width="960px">
      <el-form :model="oneForm" label-width="140px">
        <el-form-item label="分销员：" prop="updateCommissionUserId">
          <el-select style="width: 420px;" v-model="oneForm.updateCommissionUserId" placeholder="请选择">
            <el-option v-for="(item,index) in updateUserList" :key="index" :label="item.nickName" :value="item.userId"></el-option>
          </el-select>
          <div class="mt-warm-txt"><span>修改后此二级分销员下的所有用户也随之变动</span></div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分销等级弹窗 -->
    <el-dialog
      title="分销等级"
      :visible.sync="rankShow"
      width="960px">
      <el-form :model="twoForm" label-width="140px">
        <el-form-item label="分销等级：" prop="id">
          <el-select style="width: 420px;" v-model="twoForm.id" placeholder="请选择">
            <el-option v-for="(item,index) in rankList" :key="index" :label="item.promoterName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveRankBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { queryTwoUserCommissionManagePageList, updateUserCommission, queryUserCommissionUserList, queryAllCommissionPromoterLevelList, bindUserCommissionPromoterLevel } from '@/api/commission'
export default {
  name: 'CommissionMember',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 更改上级弹窗
      updateUserShow:false,
      oneForm:{
        updateCommissionUserId:''
      },
      updateUserList:[],
      // 分销等级弹窗
      rankShow:false,
      userId:'',
      twoForm:{
        id:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let userId = that.dataId
      let page = that.currentPage
      queryTwoUserCommissionManagePageList({ webCommissionSearchStr: searchName, userId: userId, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 分销等级弹窗-打开操作
    rankOpenBtn(userId){
      var that = this;
      that.userId = userId;
      queryAllCommissionPromoterLevelList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.rankList = data;
          that.rankShow = true;
        }else{
          that.$message.error(res.msg);
        }
      })
    },
    // 分销等级弹窗-保存操作
    saveRankBtn(){
      var that = this;
      let userId = that.userId;
      let id = that.twoForm.id;
      bindUserCommissionPromoterLevel({ id: id, userId: userId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.rankShow = false;
          that.getInfoList();
        }else{
          that.$message.error(res.msg);
        }
      })
    },
    /* 跳转推广订单页面 */
    toOrderBtn(infoId){
      this.$router.push({path: '/commission_order', query: {dataId: infoId}})
    },
    /* 跳转推广用户页面 */
    toPromoteBtn(infoId){
      this.$router.push({path: '/promote_users', query: {dataId: infoId}})
    },
    /* 更改上级弹窗-打开弹窗操作 */
    updateUserOpenBtn (dataId) {
      this.dataId = dataId
      let that = this
      queryUserCommissionUserList({ userId: dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.updateUserList = data;
          that.updateUserShow = true;
        }else{
          that.$message.error(res.msg);
        }
      })
    },
    // 更改上级弹窗-保存操作
    saveBtn(){
      var that = this
      var dataId = that.dataId
      var updateCommissionUserId = that.oneForm.updateCommissionUserId
      if (updateCommissionUserId === '') {
        this.$message.error('请选择分销员')
        return false
      }
      let passData = {
        userId: dataId, updateCommissionUserId: updateCommissionUserId
      }
      that.fullscreenLoading = true;
      updateUserCommission(passData).then((res) => {
        that.fullscreenLoading = false;
        if(res.errorCode == "0000"){
          that.$message.success(res.msg);
          that.oneForm.updateCommissionUserId = '';
          that.updateUserShow = false;
          that.currentPage = 1;
          that.getInfoList();
        }
        if(res.errorCode == "1001"){
          that.$message.error(res.msg);
        }
      })
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/LowerLevel.vue